export default __webpack_public_path__ + "static/rsz_energymap_b-1eed0ae8598770845c5ba6dff958f164.png";